/** StaticTextCalc — renders fixed instruction text with optional notes. */
import type { Calculator } from '@reefapp/shared';

type StaticTextCalcShape = Calculator & { kind: 'static_text' };

export interface StaticTextCalcProps {
  calculator: StaticTextCalcShape;
}

export function StaticTextCalc({ calculator }: StaticTextCalcProps) {
  return (
    <div>
      <h3 className="text-lg font-semibold text-cyan-300 mb-4">
        Instructions
      </h3>

      <div className="bg-slate-900 rounded-lg p-4 border border-slate-700">
        <p className="text-slate-300 leading-relaxed whitespace-pre-wrap">
          {calculator.text}
        </p>
      </div>

      {calculator.notes && (
        <div className="mt-4 p-3 bg-slate-900/50 border border-slate-700 rounded-lg">
          <p className="text-xs text-slate-400 whitespace-pre-wrap">
            {calculator.notes}
          </p>
        </div>
      )}
    </div>
  );
}